import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import DirectorUpdateModalSF from './DirectorUpdateModalSF'
import './DirectorList.css'

const DirectorListUI = ({ context, directorList, errorList, loan,
  // modes
  updateModeSanction, updateModeTermSheet, selectedUser,
  // event handlers
  onRefreshClick, onUpdateClick, onCancelClick, onMoveUpClick
}) =>
  <CardUI className='su_dir_props g_m_top_100' title='Promoter tokens'>
    {
      !directorList &&
      <SpinnerComponentUI />
    }
    {
      directorList && directorList.map((accountUser, i) =>
        <div key={i} className={i && 'g_m_top_100'}>
          <div className='g_flex_h g_flex_left'>
            <b>Promoter {i + 1}</b>
            <span className='icon icon-pencil g_link_2 g_m_left_50'
              data-userid={accountUser.userId} onClick={onUpdateClick} />
            {
              i != 0 &&
              <LinkWithSpinnerUI className='g_m_left_100' label='Move Up'
                onClick={onMoveUpClick} rowId={accountUser.userId} />
            }
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Name' />
            <span>{accountUser.name}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Age' />
            <span>{accountUser.age}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='PAN' />
            <span>{accountUser.panNumber}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='DIN' />
            <span>{accountUser.dinNumber}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Email' />
            <span>{accountUser.email}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Phone No.' />
            <span>{accountUser.phoneNumber}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Address' />
            <span>{accountUser.address}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='No. of shares pledged' />
            <span>{accountUser.sharePledgedNumber}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Percentage of shares pledged' />
            <span>{accountUser.sharePledgedPercent}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='NDU %' />
            <span>{accountUser.nduPercent}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Pledgor' />
            <span>{accountUser.pledgor ? 'Yes' : 'No'}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='Guarantor' />
            <span>{accountUser.guarantor ? 'Yes' : 'No'}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='CIBIL score' />
            <span className='right'>{accountUser.cibilScore}</span>
          </div>
          <div className='g_flex_h'>
            <ParamLeft name='User id' />
            <span className='right'>{accountUser.userId}</span>
          </div>
        </div>
      )
    }

    <DirectorUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateModeTermSheet}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedUser={selectedUser}
      loan={loan}
      onMoveUpClick={onMoveUpClick}
    />
  </CardUI>

const ParamLeft = ({ name }) =>
  <span className='left'>{name}</span>


export default DirectorListUI
